import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const DeleteFormModal = ({
  isShown,
  isDeletingForm,
  onConfirmDelete,
  onCancel,
  deleteFormError,
  items
}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title="Delete form"
    btnConfirmTitle="Delete"
    btnConfirmClass={ `btn-danger ${ isDeletingForm ? 'loading' : '' }` }
    btnCancelTitle="Cancel"
    onConfirm={ onConfirmDelete }
    onCancel={ onCancel }
  >
    <p>
      Are you sure you want to delete { items && items.length > 1 ? 'these forms' : 'this form' }?
    </p>
    {
      deleteFormError
      && <div className="toast toast-error">
        { deleteFormError }
      </div>
    }
  </ModalWrapper>
);

DeleteFormModal.propTypes = {
  isShown: PropTypes.bool,
  isDeletingForm: PropTypes.bool,
  onConfirmDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  deleteFormError: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({}))
};

DeleteFormModal.defaultProps = {
  isShown: false,
  isDeletingForm: false,
  deleteFormError: null,
  items: []
};

export default DeleteFormModal;
